// extracted by mini-css-extract-plugin
module.exports = {"PrismicImage":"PrismicImage_PrismicImage__tXHHs"};